var exports = {
  "Box": "Box__W4alJP",
  "Box_1": "Box_1__VcLVuG",
  "Box_2": "Box_2__QZJRED",
  "Link": "Link__m4jxSM",
  "Text": "Text__7EIwa7",
  "Button": "Button__khMAk5",
  "fadeOut": "fadeOut__GHMooZ",
  "fadedRow": "fadedRow__gYWzn7",
  "row": "row__HLQePw",
  "lastRow": "lastRow__juDN19",
};

__webpack_require__.r(module.exports = exports);
